const toTimestamp = value => {
  if (value instanceof Date) {
    const timestamp = value.getTime();
    return Number.isNaN(timestamp) ? null : timestamp;
  }

  if (typeof value === 'number' && Number.isFinite(value)) {
    return value < 100000000000 ? value * 1000 : value;
  }

  if (typeof value !== 'string' || !value.trim()) {
    return null;
  }

  const numericValue = Number(value);
  if (Number.isFinite(numericValue)) {
    return numericValue < 100000000000 ? numericValue * 1000 : numericValue;
  }

  const parsedValue = Date.parse(value);
  return Number.isNaN(parsedValue) ? null : parsedValue;
};

export const compareMessagesChronologically = (left, right) => {
  const leftTimestamp = toTimestamp(left?.created_at);
  const rightTimestamp = toTimestamp(right?.created_at);

  if (leftTimestamp !== null && rightTimestamp !== null) {
    const timestampDifference = leftTimestamp - rightTimestamp;
    if (timestampDifference !== 0) return timestampDifference;
  } else if (leftTimestamp !== null) {
    return -1;
  } else if (rightTimestamp !== null) {
    return 1;
  }

  return Number(left?.id || 0) - Number(right?.id || 0);
};

export const sortMessagesChronologically = (messages = []) =>
  [...messages].sort(compareMessagesChronologically);
